import React from 'react';
import { Edit, Trash2, MapPin, Eye } from 'lucide-react';
import EmptyState from '../Common/EmptyState';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const EnterpriseTable = ({
  enterprises,
  isLoading,
  onEdit,
  onDelete,
  onCreate,
  onView,
  onShowMap,
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!enterprises?.length) {
    return (
      <EmptyState
        icon={MapPin}
        title="Nenhum empreendimento encontrado"
        description="Ajuste os filtros ou cadastre um novo empreendimento."
        action={
          onCreate ? (
            <Can any={[P.IDENTITY_ACCESS, P.ENTERPRISES_VIEW]}>
              <button type="button" className="btn btn-primary" onClick={onCreate}>
                Novo empreendimento
              </button>
            </Can>
          ) : null
        }
      />
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Nome
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              CNPJ
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Tipo
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Ações
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {enterprises.map((enterprise) => (
            <tr key={enterprise.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm font-medium text-gray-900">
                  {enterprise.name || enterprise.nome || '—'}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900">
                  {enterprise.cnpj}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                  enterprise.status === 'ACTIVE' 
                    ? 'bg-success-100 text-success-700' 
                    : 'bg-gray-100 text-gray-700'
                }`}>
                  {enterprise.status === 'ACTIVE' ? 'Ativo' : 'Inativo'}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                  enterprise.type === 'COMMERCIAL' 
                    ? 'bg-primary-100 text-primary-700' 
                    : enterprise.type === 'INDUSTRIAL'
                    ? 'bg-warning-100 text-warning-700'
                    : 'bg-info-100 text-info-700'
                }`}>
                  {enterprise.type === 'COMMERCIAL' ? 'Comercial' : 
                   enterprise.type === 'INDUSTRIAL' ? 'Industrial' : 'Residencial'}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <Can any={[P.IDENTITY_ACCESS, P.ENTERPRISES_VIEW]}>
                  <div className="flex justify-end gap-2">
                    {onView ? (
                      <button
                        type="button"
                        onClick={() => onView(enterprise)}
                        className="text-gray-600 hover:text-gray-900"
                        title="Ver"
                      >
                        <Eye className="w-4 h-4" />
                      </button>
                    ) : null}
                    {onShowMap ? (
                      <button
                        type="button"
                        onClick={() => onShowMap(enterprise)}
                        className="text-emerald-600 hover:text-emerald-900"
                        title="Localização"
                      >
                        <MapPin className="w-4 h-4" />
                      </button>
                    ) : null}
                    <button
                      type="button"
                      onClick={() => onEdit?.(enterprise)}
                      className="text-primary-600 hover:text-primary-900"
                      title="Editar"
                    >
                      <Edit className="w-4 h-4" />
                    </button>
                    {onDelete ? (
                    <button
                      type="button"
                      onClick={() => onDelete(enterprise.id)}
                      className="text-red-600 hover:text-red-900"
                      title="Excluir"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                    ) : null}
                  </div>
                </Can>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EnterpriseTable;
